<template>
  <ion-row>
    <ion-col size="12">
      <div class="logo-wrapper">
        <img src="../../assets/svg/logo.svg">
      </div>
    </ion-col>
  </ion-row>
</template>

<script>
// import axios from "axios"
export default {
  name: "HeaderLogo",
  data: function() {
    return {}
  },
};
</script>

<style scoped>
.logo-wrapper {
  margin: 40px 0 30px;
}

.logo-wrapper img {
  height: 170px;
}
</style>